(function () {
  'use strict';

  window.RR = window.RR || {};

  var DEFAULT_MAX_AGE_SECONDS = 60 * 60 * 24 * 365 * 5;

  function formatCurrency(cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
      style: 'currency',
      currency: currency,
      maximumFractionDigits: 2,
    }).format((cents || 0) / 100);
  }

  function getCookieValue(name) {
    var rawCookie = document.cookie || '';
    var cookies = rawCookie.split(';');
    for (var i = 0; i < cookies.length; i += 1) {
      var entry = cookies[i].trim();
      if (entry.indexOf(name + '=') !== 0) continue;
      try {
        return decodeURIComponent(entry.slice(name.length + 1));
      } catch (error) {
        return '';
      }
    }
    return '';
  }

  function setCookieValue(name, value, maxAge) {
    if (!name) return;
    var cookie = name + '=' + encodeURIComponent(value || '');
    cookie += '; path=/';
    cookie += '; max-age=' + (maxAge || DEFAULT_MAX_AGE_SECONDS);
    cookie += '; SameSite=Lax';
    if (window.location && window.location.protocol === 'https:') cookie += '; Secure';
    document.cookie = cookie;
  }

  function normalize(value) {
    return (value || '').toString().toLowerCase().trim();
  }

  function escapeRegExp(value) {
    return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  window.RR.CROUtils = {
    formatCurrency: formatCurrency,
    getCookieValue: getCookieValue,
    setCookieValue: setCookieValue,
    normalize: normalize,
    escapeRegExp: escapeRegExp
  };
})();
